/**
 * Clears a ghost local Supabase session before starting OAuth.
 * Stale JWTs (user deleted server-side) can interfere with PKCE / callback exchange.
 */

import { supabase } from '../../lib/supabase'
import { authLiveDebug } from './authLiveDebug.helper'
import { logger } from '../../helpers/logger.helper'

function isGhostSessionError(message: string | undefined, status: number | undefined): boolean {
  if (!message) return false
  const lower = message.toLowerCase()
  if (lower.includes('user from sub claim') || lower.includes('does not exist')) {
    return true
  }
  return status === 403 && lower.includes('user')
}

/**
 * Validates the current session against Supabase; signs out locally when the user no longer exists.
 */
export async function clearStaleLocalSessionBeforeOAuth(): Promise<void> {
  const { data: { session } } = await supabase.auth.getSession()
  if (!session?.access_token) return

  const { error } = await supabase.auth.getUser()
  if (!error) return

  if (!isGhostSessionError(error.message, error.status)) return

  authLiveDebug('clearStaleLocalSessionBeforeOAuth — ghost session, signing out locally')
  logger.warn('[OAuth] Clearing ghost local session before provider redirect', {
    status: error.status,
  })
  await supabase.auth.signOut({ scope: 'local' })
}
